<div
  style="border-radius: 16px; background: #FFF; padding: 28px 24px 32px 24px; display: flex; flex-direction: column; align-items: flex-start; gap: 10px; width: 100%; max-width: 429px; max-height: 90vh; overflow-y: auto;">

  <div class="flex flex-col gap-5 items-start w-full">

    <div class="flex flex-col gap-7 items-start w-full">

      <div class="flex flex-col gap-1.25 items-start w-full" style="color: #212121;">
        <p style="font-family: 'Bahnschrift', sans-serif; font-size: 15px; font-weight: 700; line-height: normal;">
          Verificación de seguridad
        </p>
        <p style="font-family: 'Bahnschrift', sans-serif; font-size: 12px; font-weight: 400; line-height: normal;">
          Hemos enviado un código de verificación a tu dirección de correo electrónico registrada. Por favor, ingresa el
          código a continuación.
        </p>
      </div>

      <div class="flex flex-col gap-[4px] items-start w-full font-body">
        <label style="font-size: 12px; font-weight: 700; color: #212121; line-height: normal;">
          Código
        </label>
        <input class="auth-input" type="text" placeholder="----" [(ngModel)]="codigo" name="codigo" maxlength="6"
          autocomplete="one-time-code" />
      </div>

      <div class="captcha-box" style="margin-bottom: 28px;">
        <div class="captcha-check" [class.checked]="captchaChecked" (click)="captchaChecked = !captchaChecked"></div>
        <span class="captcha-label">No soy robot</span>
        <img src="https://deportivo-municipal.s3.us-east-2.amazonaws.com/assets/recaptcha-logo.png" alt="reCAPTCHA"
          class="captcha-logo" />
      </div>

    </div>

    <button
      class="font-display text-white uppercase cursor-pointer transition-colors duration-200 bg-rojo-brillante border-0 h-9 text-[20px] w-full rounded-2xl"
      style="padding: 0 40px; line-height: 20px;" type="button" (click)="signIn()">
      Ingresar
    </button>

  </div>
</div>